// extracted by mini-css-extract-plugin
export default {"contenedor":"SearchBar_contenedor__iU0h6","button":"SearchBar_button__T7RTc","input":"SearchBar_input__bIy50"};